export default ({children}) => {
    return <div className={"mt-10"}>
        {children}
    </div>
}
